import{ESCAPE,TOKEN_SEPARATOR,escapeSpecialChars}from"./escape.js";
import{getOtherStringTokenType}from"./other.js";


const testObject=(token)=>typeof token==="string";


const serialize=(token,index)=>{
if(token===""&&index===0){
return TOKEN_SEPARATOR
}

const chars=escapeSpecialChars(token);
return getOtherStringTokenType(chars)===undefined?
chars:
`${ESCAPE}${chars}`
};


const testString=()=>true;


const parse=(chars)=>chars;


const normalize=(token)=>token;


const equals=(tokenA,tokenB)=>tokenA===tokenB;

export const PROP_TOKEN={
name:"prop",
testObject,
serialize,
testString,
parse,
normalize,
equals
};